<script>
import i18n from "@/plugins/i18n";

export default {
    methods: {
        redirect() {
            window.open("https://app.sustainfinity.com/", "_blank");
        }
    },

    computed: {
        name() {
            return sessionStorage.getItem("name");
        }
    }
}
</script>

<template>
    <div class="register-complete-card">
        <div>
            <img src="/images/sustainfinity_logo_512x512.png" alt="sustainfinity" class="img-fluid" style="max-height: 300px;">
        </div>
        <div class="c-1" style="font-weight: 1000; font-size: 1.7em; color: var(--sustainfinity-blue); padding: 0">
            {{ $t('register.welcome') }}, <br> {{ name }}!
        </div>
        <div class="c-2">
            {{ $t('register.happy') }}
        </div>
        <div class="redirect-button" @click="redirect()">
            {{ $t('register.redirect') }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .register-complete-card {
        border-radius: 1em;

        padding-top: 1.5em !important;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        text-align: center;
        background-color: whitesmoke; // TODO: check integrity of this???

        min-width: 125px;
        max-width: 500px;
        
        height: 800px;

        padding: 1em;

        box-shadow: 0 0 1em .1em gray;

        font-weight: bold;
        font-size: 1.5em;

        > div {
            padding: 1em
        }

        > .redirect-button {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            align-items: center;
            text-align: center;

            box-shadow: 0 0 .5em .1em gray;
            background-color: var(--sustainfinity-green);
            border-radius: 1em;
            padding: .66em;

            width: 100%;
            height: fit-content;

            transition: background-color 250ms;

            cursor: pointer;
            &:hover {
                background-color: var(--sustainfinity-blue);
                text-decoration: none;
                color: white;
            }
        }
    }
</style>